import AlertTopicTypes from 'store/actionTypes/alertTopic'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  system: [],
  filter: {}
}

const AlertTopic = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case AlertTopicTypes.GET_ALERT_TOPICS_SUCCESS:
      return {
        ...state,
        list: payload?.items || []
      }
    case AlertTopicTypes.GET_ALERT_TOPIC_DETAIL_SUCCESS:
      return {
        ...state,
        current: payload || []
      }
    case AlertTopicTypes.GET_SYSTEM_ALERT_TOPICS_SUCCESS:
      return {
        ...state,
        system: payload?.items || []
      }
    case AlertTopicTypes.UPDATE_FILTER_ALERT_TOPIC_SUCCESS:
      return {
        ...state,
        filter: payload
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default AlertTopic
